import React from "react";
import {Row} from "antd";
import styled from 'styled-components';


const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      console.log(error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        return (
            <Row
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        color: "red",
                        fontSize: "20px"
                    }}
                ><StyledDiv>An error has occured, Please try again later.</StyledDiv></div>
            </Row>
        );
      }
  
      return this.props.children; 
    }
}

export default ErrorBoundary;